export const enviroment = {
  baseApi: "https://beemove-webapp.azurewebsites.net",
  // baseApi: "https://beemove-webapp-development.azurewebsites.net",
  MapsKey: "AIzaSyC8P2zQLvanWM0id5HjobOkoW91p5xad1M",
  baseUrl: "https://beemove.z20.web.core.windows.net/",
};
